import { createTranslations } from '@npco/utils-translations'

export const createSavingsAccountTranslations = createTranslations({
  title: 'Activate Zeller Savings Account',
  agreeAndActivate: 'Agree & Activate',
  // TICKET: https://npco-dev.atlassian.net/browse/TECH-397
  // Should move shared translations to a separate nx library
  cancel: 'Cancel',
})
